export enum ModelFormat {
  GLTF = 'GLTF',
}

export type ModelDesc = {
  format: ModelFormat;
  href: string;
  id: string;
  meta?: {
    meshDecals?: string[];
  } & Record<string, any>;
};
